var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0286 34.0417C30.606 34.0417 24.5703 28.0028 24.5703 20.5833C24.5703 13.1638 30.606 7.125 38.0286 7.125C45.4513 7.125 51.487 13.1638 51.487 20.5833C51.487 28.0028 45.4513 34.0417 38.0286 34.0417ZM38.0286 11.875C33.2248 11.875 29.3203 15.7795 29.3203 20.5833C29.3203 25.3872 33.2248 29.2917 38.0286 29.2917C42.8325 29.2917 46.737 25.3872 46.737 20.5833C46.737 15.7795 42.8293 11.875 38.0286 11.875ZM62.5417 66.5V57.0603C62.5417 48.6338 57.7727 38.7917 44.3334 38.7917H31.6667C18.2274 38.7917 13.4584 48.6306 13.4584 57.0603V66.5C13.4584 67.811 14.5224 68.875 15.8334 68.875C17.1444 68.875 18.2084 67.811 18.2084 66.5V57.0603C18.2084 53.8905 19.1805 43.5417 31.6667 43.5417H44.3334C56.8195 43.5417 57.7917 53.8873 57.7917 57.0603V66.5C57.7917 67.811 58.8557 68.875 60.1667 68.875C61.4777 68.875 62.5417 67.811 62.5417 66.5Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarIcon);
export default __webpack_public_path__ + "static/media/default_avatar_icon.ffd5b868678f26a6e8f1ee3412d03f94.svg";
export { ForwardRef as ReactComponent };